import { render } from "./QuickStartSection.vue?vue&type=template&id=5bf70432&scoped=true"
import script from "./QuickStartSection.vue?vue&type=script&lang=js"
export * from "./QuickStartSection.vue?vue&type=script&lang=js"

import "./QuickStartSection.vue?vue&type=style&index=0&id=5bf70432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf70432"]])

export default __exports__